import { render, staticRenderFns } from "./newcompanygroup.vue?vue&type=template&id=282bb903&"
import script from "./newcompanygroup.vue?vue&type=script&lang=js&"
export * from "./newcompanygroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports